module.exports = "<svg viewBox=\"0 0 56 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>arrow</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"arrow\" fill=\"#006f51\"><path d=\"M47,6 L47,0 L56,9.5 L47,19 L47,13 L0,13 L0,6 L47,6 Z\"></path></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 534
// module chunks = 1